import { Route, Routes } from "react-router-dom";
import AdjustmentCreateScreen from "screens/App/CRM/Payment/Adjustment/AdjustmentCreateScreen";
import AdjustmentDetailScreen from "screens/App/CRM/Payment/Adjustment/AdjustmentDetailScreen";
import AdjustmentEditScreen from "screens/App/CRM/Payment/Adjustment/AdjustmentEditScreen";
import AdjustmentListScreen from "screens/App/CRM/Payment/Adjustment/AdjustmentListScreen";

const AdjustmentRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<AdjustmentListScreen />} />
      <Route path="create" element={<AdjustmentCreateScreen />} />
      <Route path=":id/detail" element={<AdjustmentDetailScreen />} />
      <Route path=":id/edit" element={<AdjustmentEditScreen />} />
    </Routes>
  );
};

export default AdjustmentRouter;
